import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const ImageLoader = ({ src, width }) =>
  `${publicRuntimeConfig.assetsStaticBasePath}${src}?w=${width}`;

export default ImageLoader;
